import axios from "axios";

export default axios.create({
  // baseURL: "http://localhost:8440/api/usr",
  baseURL: "https://marketservant.com:8440/api/usr",
  headers: {
    "Content-type": "application/json"
  }
});